<template>
   <div>
      <div class="header-row">
         <div class="header">
            <div class="appriana-icon-cell">
               <img class="appriana-icon" src="../../assets/appriana-logo-x-small.png" @click="navigateToHome">
            </div>
            <div class="nav-title">
               <h1>{{ this.title }}</h1>
            </div>
            <div class="menu-container">
            </div>
         </div>         
      </div>
   </div>
</template>

<script>
export default {
   name: 'Landing',
   props: ['title'],
   data () {
      return {

      }
   },
   methods: {
      preventMouseDown: (e) => {},
      navigateToHome: (ev) => {
         window.location = '/';
      }
   }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.text-logo {
   text-align: left;
   width: 86px;
}

.header-row {
   border-bottom: solid 1px #EEEEEE; /* COLOR LIGHT GREY */
}

.header {
   display: grid;
   grid-template-areas: "icon title menu";
   grid-template-columns: 6rem auto 6rem;
   margin: auto;
   max-width: 64rem;
}

.appriana-icon {
   width: 42px;
   cursor: pointer;
}

.appriana-icon-cell {
   grid-area: icon;
   height: 60px;
   display: flex;
   justify-content: center;
   align-items: center;
}
.nav-title {
   grid-area: title;
   height: 60px;
   display:flex;
   justify-content:center;
   align-items:center;   
}

.nav-title h1 {
   font-size: 1.6em;
}

.menu-container {
   grid-area: menu;
   height: 60px;
   display: flex;
   justify-content: flex-end;
   align-items: center;
}

@media screen and (max-width: 740px) {
   .nav-title h1 {
      font-size: 1.2em;
   }
}

@media screen and (max-width: 500px) {
   .header {
      grid-template-columns: 5rem auto 5rem;
   }
}
</style>



// WEBPACK FOOTER //
// src/components/site/Header.vue